import { ref, onMounted, onUnmounted, readonly } from 'vue';

/**
 * Um composable reativo para detectar se o PWA está rodando em modo standalone (instalado).
 *
 * @returns {object} Um objeto contendo a referência reativa `isStandalone`.
 */
export function usePWADisplayMode() {
  // `ref` para armazenar o estado de forma reativa.
  // Inicia como `false` pois no SSR (Server-Side Rendering) não há `window`.
  const isStandalone = ref(false);

  let mediaQuery: MediaQueryList | undefined;

  // Handler que atualiza a ref
  const updateStatus = (event: MediaQueryListEvent) => {
    isStandalone.value = event.matches;
  };

  // `onMounted` garante que o código só rodará no cliente (browser)
  onMounted(() => {
    // A media query que verifica se o modo de exibição é 'standalone'
    mediaQuery = window.matchMedia('(display-mode: standalone)');

    // Define o valor inicial
    isStandalone.value = mediaQuery.matches;

    // Adiciona um listener para o caso de o estado mudar (raro, mas é uma boa prática)
    mediaQuery.addEventListener('change', updateStatus);
  });

  // `onUnmounted` garante que o listener seja removido para evitar memory leaks
  onUnmounted(() => {
    mediaQuery?.removeEventListener('change', updateStatus);
  });

  // Retornamos `readonly` para que o estado não seja modificado de fora do composable.
  return {
    isStandalone: readonly(isStandalone),
  };
}
